import React from 'react'
import withView from '../../cmn/docAutomation/withView';
import ProfileShorthandMain from "./ProfileShorthandMain";
import DocAttribute from "../../cmn/docAttribute/DocAttribute";
import FormTitle from '../../../library/form/components/FormTitle'
import useViewSwitcher from '../../../library/hooks/switch/useViewSwitcher'
import SarasViewSwitch from '../../../library/hooks/switch/SarasViewSwitch'
import SarasTabsSwitch from '../../../library/repeater/tabs/SarasTabsSwitch'
import { UiView, UiForm, UiGroupHeader, UiGroupContent } from "../../../library/layout/Index";

import FormDialog from '../../../library/form/components/FormDialog';

const profileSwitches = [
    { key: "header", val: "General", isDefault: 1 },
    { key: "tax", val: "Tax" },
    { key: "personal", val: "Personal Detail" }
]

const ProfileShorthand = (props) => {
    const { formObject, viewMap, viewData, ...restProps } = props;
    const [formAction, setFormAction] = React.useState({});

    const viewSwitcher = useViewSwitcher("header");

    const closeModel = () => {
        setFormAction({});
        restProps.onDynamicViewClose();
    }

    const onCancelClick = () => {
        setFormAction({action:'Cancel', counter: (formAction.counter || 0) + 1});
    }

    const onSaveClick = () => {
        setFormAction({action:'Save', counter: (formAction.counter || 0) + 1});
    }

    if (!viewData)
        return (null)

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            contentStyle={{ height: '450px' }}
            action={{ formActions: { forAction: "Confirm", actionFunction: onSaveClick, cancelFunction: onCancelClick, forCancel: "Cancel" }, actionParam:{showModeID:"sh" } }}
            formStyle={{ width: '743px' }} formTitle={<FormTitle formObject={formObject} value="Profile" />}
            >
            <UiView>
                <UiGroupHeader>
                    <SarasTabsSwitch viewSwitcher={viewSwitcher} switches={profileSwitches} />
                </UiGroupHeader>
                <UiGroupContent>
                    <SarasViewSwitch viewSwitcher={viewSwitcher} ctrlKey='header' hideMode='soft' >
                        <UiForm formName="Shorthand">
                            <ProfileShorthandMain viewMap={viewMap} closeModel={closeModel} formAction={formAction} viewData={viewData.childViews.proShorthand} />
                        </UiForm>
                    </SarasViewSwitch>

                    <SarasViewSwitch viewSwitcher={viewSwitcher} ctrlKey='personal' hideMode='soft' >
                        <UiForm formName="Anniv">
                            <DocAttribute viewMap={viewMap} viewData={viewData.childViews.proAnnInfo} />
                        </UiForm>
                        <UiForm formName="Specialities">
                            <DocAttribute viewMap={viewMap} viewData={viewData.childViews.proSpecialities} />
                        </UiForm>
                    </SarasViewSwitch>

                    <SarasViewSwitch viewSwitcher={viewSwitcher} ctrlKey='tax' hideMode='soft' >
                        <UiForm formName="Tax">
                            <DocAttribute viewMap={viewMap} viewData={viewData.childViews.proTaxInfo} />
                        </UiForm>
                    </SarasViewSwitch>
                </UiGroupContent>
            </UiView>
        </FormDialog>
    )
}

export default withView(ProfileShorthand, "proComp");
